import { Component } from "react";
import { createState, stateType, stateTypeF } from "./state";

import {
	BrowserRouter as Router,
	Route,
	Routes,
	useLocation,
} from "react-router-dom";

import ReactGA from "react-ga4";
import { Finance } from "./ApplicationsPage/Articles/Finance";
import { SalesLeads } from "./ApplicationsPage/Articles/SalesLeads";
import { GOOGLE_ANALYTICS_ID, ROUTES } from "./constants";
import { Dashboard } from "./dashboard/Dashboard";
import { HomePage } from "./homePage/HomePage";
import { PrivacyPage } from "./privacyPage/PrivacyPage";
import { TermsPage } from "./TermsPage/TermsPage";

export class App extends Component {
	state = createState(this);

	render() {
		if (process.env.NODE_ENV !== "development") {
			ReactGA.initialize([{ trackingId: GOOGLE_ANALYTICS_ID }]);
		}
		return (
			<Router>
				<Routes>
					<Route
						path={"/*"}
						element={<Dashboard state={this.state}></Dashboard>}
					></Route>
					<Route
						path={"/"}
						element={<HomePage state={this.state}></HomePage>}
					></Route>
					<Route
						path={ROUTES.privacy}
						element={<PrivacyPage state={this.state}></PrivacyPage>}
					/>
					<Route
						path={ROUTES.legal}
						element={<TermsPage state={this.state}></TermsPage>}
					/>
					<Route
						path={ROUTES.sales_leads}
						element={<SalesLeads state={this.state}></SalesLeads>}
					/>
					<Route
						path={ROUTES.finance}
						element={<Finance state={this.state}></Finance>}
					/>
				</Routes>
			</Router>
		);
	}
}
export async function handleError(state: stateTypeF, message, workerType?) {
	state.setErrorPopupOpen(true);
}

export function ProtectedRoute({ state }: stateType) {
	const location = useLocation();

	window.onunhandledrejection = function (e) {
		handleError(state, e.reason);
	};
	return <Dashboard state={state}></Dashboard>;
}

export default App;
